import React from "react";
import Alert from "react-bootstrap/Alert";

import "../../styles/Alert.css";

const AlertDismissible = ({ onClose }) => {
  return (
    <Alert className="mt-3 mx-5 text-center" variant="warning"
           onClose={onClose} dismissible>
           Please switch to one of the supported networks (Matic Mainnet or Mumbai or Etheruem Rinkeby) and use
        <Alert.Link className="ml-1" href="https://metamask.io/" target="blank">Metamask</Alert.Link>!
    </Alert>
  )
};

export default AlertDismissible;